const func = $target => {
	var $iframes = $target.find('.media iframe');

	$iframes.each(function() {
		var $this = $(this);
		$this.data('src', $this.attr('src'));
	});

	$(window).on('resize', function() {
		$iframes.each(function() {
			var $this = $(this);
			if ($this.is(':visible')) {
				if ($this.attr('src') == '') {
					$this.attr('src', $this.data('src'));
				}
			} else {
				$this.attr('src', '');
			}
		});
	});
};

export default func;
